import { render } from "./TaxPayment.vue?vue&type=template&id=e5772276&scoped=true"
import script from "./TaxPayment.vue?vue&type=script&lang=js"
export * from "./TaxPayment.vue?vue&type=script&lang=js"

import "./TaxPayment.vue?vue&type=style&index=0&id=e5772276&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e5772276"

export default script